import { c as _c } from "react/compiler-runtime";
export default function PcMacIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M29 26H3c-.6 0-1 .4-1 1s.4 1 1 1h26c.6 0 1-.4 1-1s-.4-1-1-1zM28 3H4c-1.1 0-2 .9-2 2v17c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 19H4V5h24v17z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}